module.exports = __webpack_public_path__ + "img/luyuanRewardSoldOut.8fe7efef.png";